/**
 * @vitest-environment jsdom
 */

import React from "react";
import { describe, expect, it } from "vitest";
import { render } from "@testing-library/react";

import Code from "../Code";

describe("Code", () => {
  it("renders a single <code> element when no highlights are present", () => {
    const { container } = render(
      <Code language="javascript" snippet={'var x = "hello";'} />,
    );
    const codeElements = container.querySelectorAll("pre > code");
    expect(codeElements.length).toBe(1);
  });

  it("wraps highlighted lines in a single <code> element", () => {
    const { container } = render(
      <Code
        language="javascript"
        snippet={'var x = "hello";\nvar y = "world";'}
        lineHighlights={{ 1: "addition" }}
      />,
    );

    const pre = container.querySelector("pre");
    const codeElements = pre?.querySelectorAll("code");
    expect(codeElements?.length).toBe(1);

    // Line content spans should be inside the <code>
    const lineSpans = codeElements?.[0].querySelectorAll(":scope > span");
    expect(lineSpans?.length).toBe(2);
  });

  it("applies highlight classes to the correct lines", () => {
    const { container } = render(
      <Code
        language="javascript"
        snippet={"line1\nline2\nline3"}
        lineHighlights={{ 1: "addition", 3: "removal" }}
      />,
    );

    const lineWrappers = container.querySelectorAll("pre > code > span");
    expect(lineWrappers.length).toBe(3);
    expect(lineWrappers[0].classList.contains("code-line-addition")).toBe(true);
    expect(lineWrappers[1].classList.contains("code-line-addition")).toBe(
      false,
    );
    expect(lineWrappers[2].classList.contains("code-line-removal")).toBe(true);
  });
});
